export default "__VITE_ASSET__f804ff8d__"